import { faStore, faTrash } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useErpSourceList } from 'context/Store';
import { tss } from 'tss-react';

import PrioritySelect from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/components/PrioritySelect';
import { Handlers } from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/useState';
import { visitSourcePage } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/ProductTableItem';
import { ImageWithFallback } from 'components/desktop/_general/ImageWithFallback/ImageWithFallback';
import { getPriceString } from 'functions/numberToString';
import useCultureCode from 'hooks/redux/useCultureCode';
import useCurrency from 'hooks/redux/useCurrency';
import useTranslation from 'hooks/useTranslation';
import * as OrderGuide from 'types/Ingredient/Detail/OrderGuide/OrderGuide';
import { ErpSourceList } from 'types/_general/Store/ErpSourceList';

interface IProps {
	orderGuide: OrderGuide.Type;
	handlers: Handlers;
}

export function OrderGuideListItem({ orderGuide, handlers }: IProps) {
	const { classes } = useStyles();
	const { t } = useTranslation();
	const erpSources = useErpSourceList();
	const cultureCode = useCultureCode();
	const currency = useCurrency();

	return (
		<div>
			{orderGuide.products.map((product, i) => {
				return (
					<div className={classes.product} key={i}>
						<div>
							<ImageWithFallback
								src={product.imageUrl}
								style={{
									width: '80px',
									height: '80px',
									objectFit: 'contain',
								}}
								onClick={() => visitSourcePage(product)}
							/>
						</div>
						<div>
							<PrioritySelect
								flexDirection="column"
								priority={product.priority ?? 0}
								togglePriority={(priority) =>
									handlers.changePriorityOfProduct({
										orderGuideId: orderGuide.id,
										productId: product.productId,
										sourceId: product.sourceId,
										priority,
									})
								}
							/>
						</div>
						<div style={{ flex: 1 }}>
							<div className={classes.gtin}>GTIN: {product.gtin}</div>
							<div>{product.name}</div>
							<div className={classes.price}>
								{`${
									product.price ? getPriceString(product.price, cultureCode) : '–'
								} ${currency}`}
							</div>
						</div>
						<div className={classes.actions}>
							<div>
								<a
									href={product.externalUrl ?? undefined}
									target="_blank"
									className={
										product.externalUrl ? classes.externalUrl : undefined
									}
								>
									<FontAwesomeIcon icon={faStore} className={classes.icon} />
									{ErpSourceList.getNameById(erpSources, product.sourceId)}
								</a>
							</div>
							<button
								className="btn btn-danger btn-sm"
								onClick={() =>
									handlers.removeProduct({
										orderGuideId: orderGuide.id,
										productId: product.productId,
									})
								}
							>
								<FontAwesomeIcon icon={faTrash} className={classes.icon} />
								{t('_general:DELETE')}
							</button>
						</div>
					</div>
				);
			})}
		</div>
	);
}

const useStyles = tss.create(() => ({
	product: {
		display: 'flex',
		alignItems: 'center',
		gap: '15px',
		border: '1px solid #ddd',
		padding: '5px',
		marginTop: '-1px',
		backgroundColor: 'white',
	},
	gtin: {
		fontSize: '12px',
		color: '#999',
	},
	actions: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		flexGrow: 1,
		gap: '12px',
		marginRight: '5px',
		justifyContent: 'space-between',
	},
	icon: {
		marginRight: '5px',
	},
	price: {
		fontSize: '0.8em',
		fontWeight: 'bold',
	},
	externalUrl: {
		pointerEvents: 'none',
		cursor: 'default',
		color: 'grey',
	},
}));
